import useIsGameCurrencyChangeEnabled from '~/client/hooks/feature/inGameCurrency/useIsGameCurrencyChangeEnabled';
import useCurrentUser from '~/client/hooks/user/useCurrentUser';

const useInitialInGameCurrency = (inGameCurrencyList?: string[]) => {
  const isGameCurrencyChangeEnabled = useIsGameCurrencyChangeEnabled();
  const profileCurrency = useProfileCurrency();

  if (!isGameCurrencyChangeEnabled) {
    return undefined;
  }
  if (inGameCurrencyList?.includes(profileCurrency)) {
    return profileCurrency;
  }
  return undefined;
};

const useProfileCurrency = () => {
  const { profile } = useCurrentUser();
  const profileCurrency = profile?.settings?.preferredInGameCurrency ?? '';
  return profileCurrency;
};

export default useInitialInGameCurrency;
